export default __webpack_public_path__ + "static/media/giphy.2085b173.gif";